import type { Contact } from './ContactTypes';
import type { ContactListFlag } from './ContactDataManagementTypes';
import { ContactFlag } from './ContactDataManagementTypes';

export function isContactMain(flags?: string[]): boolean {
    return flags?.includes(ContactFlag.MAIN_CONTACT) ?? false;
}

export function isContactInvalid(flags?: string[]): boolean {
    return flags?.includes(ContactFlag.INVALID) ?? false;
}

export function isContactUndefined(flags?: string[]): boolean {
    return flags?.includes(ContactFlag.UNDEFINED_CONTACT) ?? false;
}

export function getPrimaryContact<T extends Contact>(contacts: T[]): T | undefined {
    return contacts.find((contact) => contact.isMainContact) || contacts[0];
}

export function getContactByIdFromContacts<T extends Contact>(
    id: string | undefined,
    contacts: T[],
): T | undefined {
    return contacts.find((contact) => contact.id === id);
}

export function isContactEntryAllowed(
    flags: string[] = [],
    contactEntryNotAllowedFlag: ContactListFlag,
): boolean {
    return !flags.includes(contactEntryNotAllowedFlag);
}
